<template>
  <div class="mi-site mi-site--page">
    <a class="mi-skip" href="#main">Skip to content</a>
    <MarketingHeader />

    <main id="main" class="mi-acq">
      <div class="mi-hero-atmosphere" aria-hidden="true">
        <span class="mi-hero-orb mi-hero-orb-a"></span>
        <span class="mi-hero-orb mi-hero-orb-b"></span>
        <span class="mi-hero-orb mi-hero-orb-c"></span>
      </div>

      <section class="mi-shell mi-acq-hero-inner">
        <p class="mi-kicker">
          <span class="mi-kicker-dot" aria-hidden="true"></span>
          August 24, 2026
        </p>
        <h1>
          A new <span class="mi-grad">chapter</span>
          <span class="mi-hero-line">for MLS Ingest.</span>
        </h1>
        <p class="mi-lede">
          Today, we’re excited to share that MLS Ingest has been acquired by Brokurz.
        </p>
      </section>

      <article class="mi-article">
        <div class="mi-article-inner">
          <p>
            MLS Ingest was built around a simple idea: real estate technology should
            have a better way to connect, normalize, and deliver MLS data.
          </p>
          <p>That mission is now becoming part of something much larger.</p>
          <p>
            By joining Brokurz, the technology and infrastructure behind MLS Ingest
            will become part of the Brokurz operating system for real estate
            brokerages, helping power native listing experiences, brokerage websites,
            property search, and the next generation of real estate technology.
          </p>
          <p>
            We’re incredibly grateful to everyone who supported MLS Ingest, followed
            what we were building, collaborated with us, and believed in the vision.
          </p>
          <p>This isn’t the end of MLS Ingest. It’s the next chapter.</p>
          <p><strong>MLS Ingest is now a Brokurz company.</strong></p>
        </div>
      </article>
    </main>

    <MarketingFooter />
  </div>
</template>

<script>
import MarketingHeader from './MarketingHeader'
import MarketingFooter from './MarketingFooter'
import '../assets/marketing.css'

export default {
  name: 'AcquisitionPage',
  components: { MarketingHeader, MarketingFooter },
}
</script>
